// extracted by mini-css-extract-plugin
module.exports = {"follow-us":"style_follow-us__o0BEW"};